import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';

import MDChatViewView from 'components/features/orders/MDChatView';

const StyledOuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - 48px);
  background-color: ${hexToRGBA(theme.colors.cyanBlue, 0.08)};

  @media ${theme.devices.tablet} {
    min-height: calc(100vh - 56px);
  }
`;

const StyledInnerContainer = styled.div`
  max-width: ${theme.spaces.large26X * 10 + 32}px;
  width: 100%;

  padding-left: ${theme.spaces.regular}px;
  padding-right: ${theme.spaces.regular}px;
`;

const MDChatPage = () => {
  return (
    <StyledOuterContainer>
      <StyledInnerContainer>
        <MDChatViewView />
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

export default MDChatPage;
